import {
  AddMyFollowedEntityRequest,
  GetMyFollowedEntitiesResponse,
  GetMyFollowedEntityInfosResponse,
  RemoveMyFollowedEntityRequest,
} from '@upright/common/iam/organizations/organization-types';
import { ModelEntityReference } from '../../../../common/model/input/types';
import { fetchOrThrow, fetchOrThrowNoReturnData } from '../../common/fetchers/fetch-or-throw';

export function getMyFollowedEntities() {
  return fetchOrThrow<GetMyFollowedEntitiesResponse>('/organizations/my-followed-entities');
}

export function getMyFollowedEntityInfos(version: string) {
  return fetchOrThrow<GetMyFollowedEntityInfosResponse>(`/organizations/my-followed-entity-infos/${version}`);
}

export function followEntity(entityRef: ModelEntityReference) {
  const payload: AddMyFollowedEntityRequest = entityRef;
  return fetchOrThrowNoReturnData('/organizations/my-followed-entities', 'POST', payload);
}

export function unfollowEntity(entityRef: ModelEntityReference) {
  const payload: RemoveMyFollowedEntityRequest = entityRef;
  return fetchOrThrowNoReturnData('/organizations/my-followed-entities', 'DELETE', payload);
}
